import React, { FunctionComponent } from 'react';
import type { RecruitmentShowBottomItemFirstProps } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowBottomItemFirstProps & {
  applications: Recruitment[];
};

export const Presentation: FunctionComponent<Props> = ({
  title,
  recruitmentId,
  noimage,
  isStopped,
  dataCategory,
  dataValue,
  applications,
  isPreview
}) => {
  if (applications.length === 0) return null

  return (
    <div className="recruitment__show__bottom__wrapper__content">
      <h2 className="mainTitle">{title}</h2>
      <div className="recruitment__show__applications__slider js-recruitment-bottom-first">
        {applications.map((app) => (
          <a
            key={app.id}
            href={`/recruitments/${app.id}`}
            className={`box ${!isPreview ? 'gtm-recruitment-view-count' : ''}`}
            target="_blank"
            rel="noopener noreferrer"
            {...(!isPreview && {
              'data-event-name': 'recruitments on screen',
              'data-event': 'click',
              'data-category': isStopped ? dataCategory.stopRecruitmentContent : dataCategory.recruitmentContent,
              'data-value': dataValue.relatedRecruitments,
              'data-recruitmentid': app.id,
              'data-companyid': app.companyId
            })}
          >
            {app.image.url !== null ? (
              <img src={app.image.url} alt={`${app.title}の画像`} />
            ) : (
              <img src={noimage} alt={`${app.title}の画像`} />
            )}
            <p className="title">
              <span className="occupation">{app.title}</span>
              <span className="prefecture">{app.prefecture}</span>
            </p>
            <p className="body">{app.body}</p>
            <div className="bottomBox">
              {app.icon !== null ? (
                <img src={app.icon} alt={`${app.title}の画像`} className="icon" />
              ) : (
                <img src={noimage} alt={`${app.title}の画像`} className="icon" />
              )}
              <p className="companyName">{app.companyName}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
